import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Bell(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="128"
      viewBox="0 0 160 128"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2502_19306"
          x1="114.291"
          x2="39.533"
          y1="96.6681"
          y2="2.91958"
        >
          <stop offset="0.00571742" stopColor="#F4F7FE" />
          <stop offset="0.9374" stopColor="white" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2502_19306"
          x1="40.1627"
          x2="114.902"
          y1="40.6437"
          y2="40.738"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_2502_19306"
          x1="68.8934"
          x2="85.9624"
          y1="84.2241"
          y2="84.2456"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
      </defs>
      <path
        d="M128.249 78.7758C96.5093 95.4072 103.602 116.478 69.4688 126.516C42.1052 134.568 13.2915 108.508 2.99825 80.9076C-1.68257 68.3639 -1.5323 47.2072 8.14113 31.3649C12.1532 24.7976 17.7958 19.1466 25.4106 15.3954C49.3631 3.59599 60.5204 17.5608 80.8478 15.545C87.4896 14.8868 95.1119 12.5194 104.481 6.9881C138.419 -13.0466 153.611 15.3954 157.882 25.022C163.149 36.885 160.433 61.9125 128.249 78.7758Z"
        fill="url(#paint0_linear_2502_19306)"
      />
      <path
        clipRule="evenodd"
        d="M112.709 68.827C114.019 69.3926 114.866 70.6841 114.864 72.1147C114.861 74.0874 113.259 75.6835 111.287 75.6823L105.186 75.68L103.318 75.6793L51.6623 75.6444L49.7944 75.6437L43.6927 75.6415C41.7214 75.6403 40.1227 74.0399 40.1252 72.0671C40.1276 70.6366 40.9808 69.3465 42.2954 68.7814L49.8094 65.5575L49.8382 44.021C49.8587 28.3268 60.4831 15.49 74.1092 13.5719L74.1131 9.14349C74.1157 7.2266 75.671 5.67372 77.5829 5.67398C79.4984 5.67549 81.0491 7.23101 81.0465 9.14789L81.0426 13.5763C94.6607 15.5109 105.251 28.3595 105.23 44.0573L105.201 65.5938L112.709 68.827Z"
        fill="url(#paint1_linear_2502_19306)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M77.4233 88.6463C72.7167 88.6416 68.8922 84.6775 68.8989 79.8116L85.9681 79.8211C85.9649 84.6883 82.1312 88.6475 77.4233 88.6463Z"
        fill="url(#paint2_linear_2502_19306)"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default Bell
